import Component from '_core_ext/components/Component';
import 'slick-carousel';
import 'jquery-touchswipe';

export default class Slick extends Component {
    static get selector() {
        return '.js-component-slick';
    }
    get configDefault() {
        return {
            'dots': false,
            'infinite': true,
            'autoplay': true,
            'autoplaySpeed': 7000,
            'pauseOnHover': true,
            'speed': 1000,
            'fade': true,
            'cssEase': 'ease-in-out',
            'prevArrow': '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
            'nextArrow': '<button type="button" class="slick-next" aria-label="Next slide"></button>',
            'accessibility': false
        };
    }
    get configDataAttrName() {
        return 'component-slick';
    }
    /**
     * Method called when creating component
     *
     * @constructor
     * @param {array} args {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator}
     */
    init(...args) {
        this.$window = $(window);
        //fallback, for direct initialization
        if (!('slick' in $.fn)) {
            return false;
        }
        //call parent init method with same args
        super.init(...args);

        this.unslickWidth = parseInt(this.$el.data('unslickWidth'), 10);
        this.isPaused = false;

        if (isNaN(this.unslickWidth)) {
            this.$el.slick(this.config);
            this.initPauseButton();

            this.fixAriaHidden();
            this.$el.on('afterChange', () => this.fixAriaHidden());
            this.$window.on('resize', () => {
                if (this.$el.hasClass('slick-initialized')) {
                    this.fixAriaHidden();
                }
            });
        }

        // Hack for safari and android browser to prevent page vertical scroll on carousel swiping
        this.$el.on('touchstart', () => { this.swiping = true; });
        this.$el.on('touchend', () => { this.swiping = false; });
        window.addEventListener('touchstart', (e) => this.touchStart(e));
        window.addEventListener('touchmove', (e) => this.preventTouch(e), {passive: false});
    }

    fixAriaHidden() {
        if (this.config.fade) {
            return;
        }

        const $slides = this.$el.find('.slick-slide');
        const $slickList = this.$el.find('.slick-list');
        const containerRect = $slickList[0].getBoundingClientRect();

        $slides.each((index, slide) => {
            const $slide = $(slide);
            const slideRect = slide.getBoundingClientRect();

            const slideLeft = slideRect.left;
            const slideRight = slideRect.right;
            const containerLeft = containerRect.left;
            const containerRight = containerRect.right;

            const isPartiallyVisible = slideRight > containerLeft && slideLeft < containerRight;

            const visibleLeft = Math.max(slideLeft, containerLeft);
            const visibleRight = Math.min(slideRight, containerRight);
            const visibleWidth = Math.max(0, visibleRight - visibleLeft);
            const slideWidth = slideRect.width;
            const visiblePercentage = (visibleWidth / slideWidth) * 100;

            const isVisible = isPartiallyVisible && visiblePercentage >= 10;

            $slide.attr('aria-hidden', isVisible ? 'false' : 'true');

            const $focusable = $slide.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

            if (isVisible) {
                $focusable.each((i, el) => {
                    const $el = $(el);
                    if (!$el.data('original-tabindex')) {
                        $el.data('original-tabindex', $el.attr('tabindex') || '0');
                    }
                    $el.attr('tabindex', $el.data('original-tabindex'));
                });
            } else {
                $focusable.attr('tabindex', '-1');
            }
        });
    }

    initPauseButton() {
        const $pauseBtn = this.$el.closest('.content-panel').find('.js-carousel-pause');

        if ($pauseBtn.length) {
            $pauseBtn.on('click', () => {
                this.togglePause($pauseBtn);
            });
        }
    }

    togglePause($btn) {
        if (this.isPaused) {
            this.$el.slick('slickPlay');
            this.isPaused = false;
            $btn.attr({'aria-label': 'Pause Carousel','title': 'Pause Carousel'});
            $btn.find('.icon-zpause-icon').show();
            $btn.find('.icon-zplay-icon').hide();
        } else {
            this.$el.slick('slickPause');
            this.isPaused = true;
            $btn.attr({'aria-label': 'Play Carousel','title': 'Play Carousel'});
            $btn.find('.icon-zpause-icon').hide();
            $btn.find('.icon-zplay-icon').show();
        }
    }

    unSlickHandler() {
        if ((this.unslickWidth > 0 && window.innerWidth > this.unslickWidth) ||
                (this.unslickWidth < 0 && -window.innerWidth > this.unslickWidth)) {
            if (this.$el.hasClass('slick-initialized')) {
                this.$el.slick('unslick');
            }
            return;
        }
        if (!this.$el.hasClass('slick-initialized')) {
            this.$el.slick(this.config);
            this.initPauseButton();
        }
    }

    touchStart(e) {
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }

    preventTouch(e) {
        if (this.swiping === true) {
            const minValue = 5; // threshold

            this.clientX = e.touches[0].clientX - this.firstClientX;
            this.clientY = e.touches[0].clientY - this.firstClientY;

            // Vertical scrolling does not work when you start swiping horizontally.
            if (Math.abs(this.clientX) > minValue) {
                e.preventDefault();
                e.returnValue = false;
                return false;
            }
        }
    }
}

module.exports = Slick;
